import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-d26d0ef0"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "video-title"
};
const _hoisted_2 = {
  class: "preview-wrapper"
};
import VideoPreview from './VideoPreview.vue';
export default {
  props: {
    show: Boolean,
    videoInfo: Object
  },
  emits: ['update:show'],

  setup(__props, {
    emit
  }) {
    const props = __props;

    const handleClose = () => {
      emit('update:show', false);
    };

    return (_ctx, _cache) => {
      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        modelValue: props.show,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => props.show = $event),
        width: "800px",
        "before-close": handleClose,
        "destroy-on-close": "",
        "close-on-click-modal": false
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString(__props.videoInfo.title), 1)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(VideoPreview, {
          videoUrl: __props.videoInfo.url
        }, null, 8, ["videoUrl"])])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};